import React, { useEffect, useState, useRef } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom'; 
import { Grid } from '@material-ui/core';
import styles from './style';
import { PatientList } from './components';
import { connect } from 'react-redux';
 
const Default = props => {
  const { classes, ehrID, userID, allAppointments } = props; 

  return (
    <div className={classes.root}>
      <Grid className={classes.contentWrap} container xs={12}> 
          <PatientList /> 
      </Grid>
    </div>
  );
};

const mapDispatchToProps = { };

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  userID: state.profile && state.profile.userID, 
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Default))
);
